// extracted by mini-css-extract-plugin
module.exports = {"box":"FJThumbnailContainer_box__3mgSJ","name":"FJThumbnailContainer_name__Lo21g"};